import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  getExperienceBasicInfo,
  getVariationById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderGroupToggled } from "@src/utils/mixpanel";

export interface TrackGroupToggledPayload {
  variationId: string;
}

export const trackGroupToggled = createAsyncThunk<
  void,
  TrackGroupToggledPayload
>("experienceBuilder/tracking/groupToggled", (payload, { getState }) => {
  const experienceInfo = getExperienceBasicInfo(getState());
  if (!experienceInfo) {
    return;
  }

  const { experienceId, experienceName, experienceType } = experienceInfo;
  const getVariation = getVariationById(getState());
  const variation = getVariation(payload.variationId);
  const mods = experienceBuilderSlice.selectors.getMods(getState());
  const variationMods = mods.filter(
    (m) => m.variationId === payload.variationId
  );
  const device = experienceBuilderSlice.selectors.getDevice(getState());

  mpVisualBuilderGroupToggled({
    experienceId,
    experienceName,
    experienceType,
    groupName: variation?.name ?? "Unknown",
    groupId: payload.variationId,
    modCount: variationMods.length,
    builderMode: device,
  });
});
